<div>
  <ng-content></ng-content>
  <span class="count">{{ count }}</span>
</div>